import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter';

const TurnipCharacter = (props) => {
    const primaryColor = "#f3e5f5"; // Light purple-white
    const secondaryColor = "#e1bee7"; // Slightly more purple shade

    const renderTurnipBody = () => (
        <>
            {/* Turnip Body - inverted cone shape */}
            <mesh castShadow position={[0, 0, 0]}>
                <sphereGeometry args={[0.3, 16, 16]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Purple top half coloring */}
            <mesh castShadow position={[0, 0.15, 0]}>
                <sphereGeometry args={[0.28, 16, 16, 0, Math.PI * 2, 0, Math.PI / 2]} />
                <meshStandardMaterial color="#ce93d8" />
            </mesh>

            {/* Turnip greens/stem */}
            <group position={[0, 0.3, 0]}>
                {/* Main stem */}
                <mesh castShadow>
                    <cylinderGeometry args={[0.02, 0.02, 0.2, 8]} />
                    <meshStandardMaterial color="#7cb342" />
                </mesh>

                {/* Leaves */}
                {[...Array(4)].map((_, i) => {
                    const angle = (i / 4) * Math.PI * 2;
                    const x = Math.sin(angle) * 0.1;
                    const z = Math.cos(angle) * 0.1;
                    return (
                        <mesh key={i} position={[x, 0.05, z]} rotation={[0.4, angle, 0]} castShadow>
                            <coneGeometry args={[0.05, 0.2, 8, 1, true]} />
                            <meshStandardMaterial color="#8bc34a" side={2} />
                        </mesh>
                    );
                })}
            </group>

            {/* Root wisps at bottom */}
            <mesh castShadow position={[0, -0.3, 0]}>
                <coneGeometry args={[0.05, 0.1, 8]} />
                <meshStandardMaterial color="#e0e0e0" />
            </mesh>
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderTurnipBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default TurnipCharacter;
